import React from 'react';
import Container from '@mui/material/Container';
import Box from '@mui/material/Box';
import Typography from './modules/components/Typography';
import AppAppBar from './modules/views/AppAppBar';
import AppFooter from './modules/views/AppFooter';
import withRoot from './modules/withRoot';


const CONTENT: string = `Welcome to Gallery Lambda - an organization and brand dedicated to crafting creative products with a profound mission: to leave the world in a better place than we encountered it.

    Cheers to embracing the future, one step at a time - Gallery Lambda.
`;

function AboutUs() {
    return (
        <React.Fragment>
            <AppAppBar />
            <Container>
                <Box sx={{ mt: 7, mb: 12 }}>
                    <Typography variant="h3" gutterBottom marked="center" align="center">
                        About Us
                    </Typography>
                </Box>
                <Box>
                    <Typography
                        color="inherit"
                        align="left"
                        variant="h5"
                        sx={{ mb: 10, mt: { sx: 5, sm: 5 } }}
                    >
                        {CONTENT.split('\n').map((line, index) => (
                            <React.Fragment key={index}>
                                {line}
                                <br />
                            </React.Fragment>
                        ))}
                    </Typography>
                </Box>
            </Container>
            <AppFooter />
        </React.Fragment>
    );
}

export default withRoot(AboutUs);

